const prefix = '/value-chain-maps/customers';

export const VC_CUSTOMER_LIST_TAG = `${prefix}`;
export const VC_CUSTOMER_RECORD_TAG = `${prefix}/{id}`;

export default VC_CUSTOMER_LIST_TAG;
